import type { ParagraphTwoBoxes as ParagraphTwoBoxesData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import { Attachments } from "../shared/Attachments";
import { Box } from "../shared/Box";
import styles from "../Paragraph.module.css";

/**
 * Layout 17 - `PARAGRAPH_TWO_BOXES_LAYOUT`: 2 boksy z obrazem + tytułem + CTA.
 *
 * Każdy boks ma swój własny tytuł (`name` -> boks 1, `name_1` -> boks 2). Akapit
 * NIE renderuje nadrzędnego nagłówka (`ParagraphHeading`) - boksy same niosą tytuły,
 * dodatkowy heading dublowałby tytuł boksu 1 na samej górze.
 *
 * Każdy boks może mieć własny background-color (hex bez `#` z bazy), obraz
 * (URL pełen z `_ENV[fullhost]` w PHP), tytuł, tekst, link CTA.
 */
export function ParagraphTwoBoxes({
  paragraph,
  t,
}: {
  paragraph: ParagraphTwoBoxesData;
  t: ParagraphTranslations;
}) {
  return (
    <section className={styles.paragraph}>
      <div className={`${styles.boxes} ${styles.boxesTwo}`}>
        <Box
          name={paragraph.name}
          text={paragraph.text}
          image={paragraph.image}
          color={paragraph.color}
          buttonName={paragraph.button_name}
          buttonUrl={paragraph.button_url}
        />
        <Box
          name={paragraph.name_1}
          text={paragraph.text_1}
          image={paragraph.image_1}
          color={paragraph.color_1}
          buttonName={paragraph.button_name_1}
          buttonUrl={paragraph.button_url_1}
        />
      </div>
      <Attachments files={paragraph.attachments} t={t} />
    </section>
  );
}

